var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#32325D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M10.667 7.111v2.37c0 .655-.531 1.186-1.186 1.186H1.185C.531 10.667 0 10.136 0 9.48v-2.37M8.296 2.963L5.333 0 2.37 2.963M5.333 1.185L5.333 8.296",
    transform: "translate(2.667 2.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c314dd3274520ddc5124ab0de1ea8edd.svg";
export { ForwardRef as ReactComponent };